import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import classNames from "classnames";
import React from "react";

export interface PaginationProps {
  offset: number;
  limit: number;
  total: number;
  setOffset: (offset: number) => void;
  style?: any;
}

const Pagination = ({
  offset,
  limit,
  total,
  setOffset,
  style,
}: PaginationProps) => {
  const onPrev = () => {
    if (offset > 0) {
      setOffset(offset - limit);
    }
  };

  const onNext = () => {
    if (offset + limit < total) {
      setOffset(offset + limit);
    }
  };

  return (
    <div className="w-full">
      <div
        style={style}
        className="text-gray-500 text-sm border rounded-lg divide-gray-300 divide-x flex gap-6 ml-auto w-max m-2 p-2 items-center"
      >
        <div>
          <span className="font-semibold">
            {`${offset + 1}-${Math.min(offset + limit, total)}`}
          </span>{" "}
          <span>{`of ${total}`}</span>
        </div>
        <div className="flex gap-4">
          <ChevronLeftIcon
            className={classNames("size-5 ml-3 cursor-pointer", {
              "text-gray-300 cursor-not-allowed": offset === 0,
            })}
            onClick={onPrev}
          />
          <ChevronRightIcon
            className={classNames("size-5 cursor-pointer", {
              "text-gray-300 cursor-not-allowed": offset + limit >= total,
            })}
            onClick={onNext}
          />
        </div>
      </div>
    </div>
  );
};

export default Pagination;
